'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = wrapField;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _gridClassName = require('./gridClassName');

var _gridClassName2 = _interopRequireDefault(_gridClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function wrapField(_ref, children) {
    var checkboxes = _ref.checkboxes,
        className = _ref.className,
        disabled = _ref.disabled,
        error = _ref.error,
        errorMessage = _ref.errorMessage,
        feedbackable = _ref.feedbackable,
        grid = _ref.grid,
        help = _ref.help,
        helpClassName = _ref.helpClassName,
        id = _ref.id,
        inline = _ref.inline,
        inputClassName = _ref.inputClassName,
        inputRef = _ref.inputRef,
        label = _ref.label,
        required = _ref.required,
        rows = _ref.rows,
        showInlineError = _ref.showInlineError,
        transform = _ref.transform,
        wrapClassName = _ref.wrapClassName,
        props = (0, _objectWithoutProperties3.default)(_ref, ['checkboxes', 'className', 'disabled', 'error', 'errorMessage', 'feedbackable', 'grid', 'help', 'helpClassName', 'id', 'inline', 'inputClassName', 'inputRef', 'label', 'required', 'rows', 'showInlineError', 'transform', 'wrapClassName']);

    var hasWrap = !!(grid || wrapClassName);

    var blockError = !!(error && showInlineError) && _react2.default.createElement(
        'span',
        { className: 'help-block' },
        errorMessage
    );

    var blockFeedback = !!(error && feedbackable) && _react2.default.createElement('i', { className: 'glyphicon glyphicon-remove form-control-feedback' });

    var blockHelp = !!help && _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('help-block', helpClassName) },
        help
    );

    return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
            className: (0, _classnames2.default)(className, 'field', 'form-group', {
                'has-feedback': error && feedbackable,
                'has-error': error,
                disabled: disabled,
                required: required
            })
        }, (0, _filterDOMProps2.default)(props)),
        label && _react2.default.createElement(
            'label',
            { htmlFor: id, className: (0, _classnames2.default)('control-label', (0, _gridClassName2.default)(grid, 'label')) },
            label
        ),
        hasWrap && _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(wrapClassName, (0, _gridClassName2.default)(grid, 'input')) },
            children,
            blockFeedback,
            blockHelp,
            blockError
        ),
        !hasWrap && children,
        !hasWrap && blockFeedback,
        !hasWrap && blockHelp,
        !hasWrap && blockError
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/uniforms-bootstrap3/wrapField.js
 ** module id = ./node_modules/uniforms-bootstrap3/wrapField.js
 ** module chunks = 0
 **/